import { render, staticRenderFns } from "./MonthDasboard.vue?vue&type=template&id=1bc71bcc&scoped=true"
import script from "./MonthDasboard.vue?vue&type=script&lang=js"
export * from "./MonthDasboard.vue?vue&type=script&lang=js"
import style0 from "./MonthDasboard.vue?vue&type=style&index=0&id=1bc71bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc71bcc",
  null
  
)

export default component.exports